module.exports = __webpack_public_path__ + "img/fishing_pole.c3d561a3.gif";